import React, { useState, useEffect, useRef, useMemo } from "react";
import "./NewDashboard.css";
import Dashboard from "../Dashboard/Dashboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config";
import ResultChart from "../ResultChart/ResultChart";
import Subscriptions from "../Subscriptions/Subscriptions";
import { useNavigate } from "react-router-dom";
import gg from "../../images/pp-logo.gif";
import noimage from "../../images/image.jpeg";
import DashboardTwoCard from "../DashboardTwoCard/DashboardTwoCard";
import DoughnutLinearChart from "../DoughnutLinearChart/DoughnutLinearChart";

import vec from "../../images/Vector.svg";
import v1 from "../../images/v1.svg";
import v2 from "../../images/v2.svg";
import v3 from "../../images/v3.svg";
import du from "../../images/dm.svg";
import gl from "../../images/glo.svg";
import DilemaPop from "../DilemaPop/DilemaPop";
// import ww from "../../images/white-lock.svg";
import ww from "../../images/yellow-loc.svg";
import { Helmet } from "react-helmet";
function NewDashboard({
  globaltest,
  token,
  onLoginChange,
  free_test_slug,
  userdetail,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [UserData, setUserData] = useState([]);
  const [TestDates, setTestDates] = useState([]);
  const [BadgeImage, setBadgeImage] = useState("");
  const [testData, settestData] = useState([]);
  const [Avertisment, setAdvertisment] = useState([]);
  const [HeaderTest, setHeaderTest] = useState([]);
  const [Opacity, setOpacity] = useState(true);
  const [Demension, setDemension] = useState([]);
  const [SubPlan, setSubPlan] = useState("hide_graph");
  const [HavePastTest, setHavePastTest] = useState(false);
  const [Ebook, setEbook] = useState([]);
  const [IsTest, setIsTest] = useState(false);
  const TestDone = useRef(null);
  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;
  const [DataContent, setDataContent] = useState([]);
  const [showPopup, setShowPopup] = useState(true);

  const [showResult, setShowResult] = useState(false);

  const [ButtonLoad, setButtonLoad] = useState(false);
  const [UserSub, setUserSub] = useState(true);
  // const first_login = localStorage.getItem("first_login");
  const [first_login, setfirst_login] = useState(true);
  const [iamgeload, setiamgeload] = useState(false);

  const [page, setPage] = useState(0);
  // const [totalDates, setTotalDates] = useState(0);
  const itemsPerPage = 5;

  const [dataCache, setDataCache] = useState({});
  const [slideDirection, setSlideDirection] = useState("");
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [prefetchInProgress, setPrefetchInProgress] = useState(new Set());
  const [isVisible, setIsVisible] = useState(false);

  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const [TestLink, setTestLink] = useState(null);

  const [TestLink1, setTestLink1] = useState(null);

  const [TestLink2, setTestLink2] = useState(null);

  const [Notification, setNotification] = useState(null);

  const [tierData, setTierData] = useState([]);

  const [JourneyData, setJourneyData] = useState([]);

  const [showlock, setshowlock] = useState(true);

  const [LockModal, setLockModal] = useState(false);

  const HandleLockModal = () => {
    setLockModal(true);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  const handleFirstLoginClose = async () => {
    setfirst_login(true);

    try {
      const response = await fetch(`${END_URL}/update-first-login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          first_login: true,
        }),
      });

      const result = await response.json();
    } catch (error) {
      console.error("Failed to update first_login", error);
    }
  };

  const result_letter = useMemo(() => {
    return (
      testData?.data?.map((item) => ({
        final_letter:
          item.letter === "left" ? item.leftletter : item.rightletter,
      })) || []
    );
  }, [testData]);

  const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.onload = resolve;
      img.onerror = reject;
    });
  };

  useEffect(() => {
    if (DataContent?.sub_pop_up_image) {
      const imageUrl = `${IMG_URL}/d0/${DataContent.sub_pop_up_image}`;
      preloadImage(imageUrl)
        .then(() => {
          console.log("Popup image preloaded");
        })
        .catch(() => {
          console.log("Failed to preload popup image");
        });
    }
  }, [DataContent]);

  useEffect(() => {
    GetInitialUserData();
  }, []);

  // useEffect(() => {
  //   if (totalDates > 0 && !isLoading) {
  //     prefetchAdjacentPages();
  //   }
  // }, [page, totalDates, isLoading]);

  const handleNavigeteTest = (link) => {
    navigate(`/${link}`);
  };

  const handleNavigete = (link) => {
    const storedSubIds = localStorage.getItem("pendingSubIds");

    if (storedSubIds) {
      let subIds = [];

      try {
        subIds = JSON.parse(storedSubIds);

        handleAdSub(subIds);

        return 0;
      } catch (e) {
        console.error("Invalid JSON in localStorage:", e);
      }
    }

    if (link) {
      window.location.href = `${link}`;
    }
  };

  const handleAdSub = async (subJson) => {
    try {
      let subIds = [];
      const storedSubIds = localStorage.getItem("pendingSubIds");

      if (storedSubIds) {
        try {
          subIds = JSON.parse(storedSubIds);
        } catch (e) {
          console.error("Invalid JSON in localStorage:", e);
        }
      }

      if ((!Array.isArray(subIds) || subIds.length === 0) && subJson) {
        if (typeof subJson === "string") {
          try {
            subIds = JSON.parse(subJson);
          } catch (e) {
            console.error("Invalid JSON string for subIds:", e);
            return;
          }
        } else if (Array.isArray(subJson)) {
          subIds = subJson;
        }
      }

      if (!Array.isArray(subIds) || subIds.length === 0) {
        console.warn("No valid subscription IDs found:", subIds);
        return;
      }

      setShowPopup(false);
      setShowModal(true);

      setShowResult(false);

      const res = await axios.post(
        `${END_URL}/sub_adver`,
        { ids: subIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSubscription(res.data);

      localStorage.removeItem("pendingSubIds");
    } catch (err) {
      console.error("Error loading subscriptions:", err);
    }
  };

  const handleSub = async (subJson) => {
    try {
      let subIds = [];

      if (typeof subJson === "string") {
        try {
          subIds = JSON.parse(subJson);
        } catch (e) {
          console.error("Invalid JSON string for subIds:", e);
          return;
        }
      } else if (Array.isArray(subJson)) {
        subIds = subJson;
      }

      setShowPopup(false);
      setShowModal(true);

      setShowResult(false);

      const res = await axios.post(
        `${END_URL}/sub_adver`,
        { ids: subIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSubscription(res.data);

      localStorage.removeItem("pendingSubIds");
    } catch (err) {
      console.error("Error loading subscriptions:", err);
    }
  };

  const handleResult = async (subJson) => {
    try {
      let subIds = [];

      if (typeof subJson === "string") {
        try {
          subIds = JSON.parse(subJson);
        } catch (e) {
          console.error("Invalid JSON string for subIds:", e);
          return;
        }
      } else if (Array.isArray(subJson)) {
        subIds = subJson;
      }

      setShowPopup(false);
      setShowModal(true);

      setShowResult(true);

      const res = await axios.post(
        `${END_URL}/sub_adver`,
        { ids: subIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSubscription(res.data);

      localStorage.removeItem("pendingSubIds");
    } catch (err) {
      console.error("Error loading subscriptions:", err);
    }
  };

  const GetInitialUserData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${END_URL}/get_user_data`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page: 0,
          per_page: itemsPerPage,
        },
      });

      const responsedata = response?.data;

      setUserData(responsedata?.user_data);
      setTestDates(responsedata?.unique_test_created_date);
      // setTotalDates(responsedata?.total_dates || 0);
      setBadgeImage(responsedata?.badge_image);
      setEbook(responsedata?.ebook_file);
      setAdvertisment(responsedata?.advertisments);

      setHeaderTest(responsedata?.dashboard_header);

      setDataContent(responsedata?.data_content);
      setUserSub(responsedata?.user_have_sub);

      setTestLink(responsedata?.test_disable);

      setTestLink1(responsedata?.no_test_btn_link_section?.slug);

      setTestLink2(responsedata?.sub_bottom_image_link?.slug);

      setNotification(responsedata.filteredNotifications);

      setfirst_login(responsedata?.first_login);

      setJourneyData(responsedata?.journey_data);

      setshowlock(responsedata?.data?.test_done_subscription ? false : true);

      setDataCache((prev) => ({
        ...prev,
        [0]: {
          user_data: responsedata?.user_data,
          unique_test_created_date: responsedata?.unique_test_created_date,
        },
      }));

      if (responsedata.test) {
        setIsTest(true);
      }

      setDemension(responsedata?.dimensions || []);

      setTierData(responsedata?.trait_tiers || []);

      // const test = {
      //   test: {
      //     id: responsedata?.test?.id || null,
      //     name: responsedata?.test?.name || "",
      //     type: responsedata?.test?.type || "",
      //     slug: responsedata?.test?.slug || "",
      //     test_slug: responsedata?.data?.test_slug || "",
      //     result_test_name: responsedata?.test?.result_test_name || "",
      //   },
      // };

      // const resultdata = {
      //   data:
      //     responsedata?.data?.categoryresult?.map((item) => ({
      //       category_id: item?.id || null,
      //       left_result: item?.left_result || 0,
      //       leftlabel: item?.resultcategory?.left_label || "",
      //       leftletter: item?.resultcategory?.leftletter || "",
      //       letter: item?.letter || "",
      //       name: item?.name || "",
      //       right_result: item?.right_result || 0,
      //       rightlabel: item?.resultcategory?.right_label || "",
      //       rightletter: item?.resultcategory?.rightletter || "",
      //     })) || [],
      // };

      // const ConvertedtestData = {
      //   ...resultdata,
      //   result: responsedata?.data?.result || null,
      //   ...test,
      // };

      const ConvertedtestData = {
        test: {
          id: responsedata?.test?.id ?? null,
          name: responsedata?.test?.name ?? "",
          type: responsedata?.test?.type ?? "",
          slug: responsedata?.test?.slug ?? "",
          test_slug: responsedata?.data?.test_slug ?? "",
          result_display_name: responsedata?.data?.test?.result_test_name ?? "",
        },
        data: responsedata?.data?.categoryresult ?? [],
        result: responsedata?.data?.result ?? null,
        test_link: responsedata?.data?.test_link ?? null,
        test_sub_ids: responsedata?.data?.test_sub_ids ?? null,
        test_popup_content:responsedata?.data?.test_popup_content ?? null,
      };

      settestData(ConvertedtestData);

      setIsLoading(false);
    } catch (error) {
      console.log("Error fetching initial user data:", error);
      setIsLoading(false);
    }
  };

  const [trait_tiers, settrait_tiers] = useState([]);

  useEffect(() => {
    if (tierData?.trait_tiers) {
      settrait_tiers(tierData.trait_tiers);
    }
  }, [tierData]);

  const traits = useMemo(() => {
    if (!testData?.data?.length) return [];

    return testData.data.map((item) => {
      const leftLabel = item.resultcategory?.left_label || "";
      const rightLabel = item.resultcategory?.right_label || "";

      const label = item.letter === "left" ? leftLabel : rightLabel;

      const value = Math.round(
        item.letter === "left"
          ? parseFloat(item.left_result)
          : parseFloat(item.right_result),
      );

      const content_left = item.resultcategory?.label_content || "";
      const content_right = item.resultcategory?.label_content_right || "";

      const color_left_1 = item.resultcategory?.left_label_one || "";

      const color_left_2 = item.resultcategory?.left_label_two || "";

      const color_right_1 = item.resultcategory?.right_label_one || "";

      const color_right_2 = item.resultcategory?.right_label_two || "";

      const content = item.letter === "left" ? content_left : content_right;

      const bg_color_1 = item.letter === "left" ? color_left_1 : color_right_1;

      const bg_color_2 = item.letter === "left" ? color_left_2 : color_right_2;

      const showlock = item.resultcategory?.show_lock || false;

      const result_display_name = item?.test?.result_test_name;

      return { label, value, content, bg_color_1, bg_color_2, showlock,result_display_name };
    });
  }, [testData]);

  const sortedTiers = useMemo(() => {
    if (!trait_tiers?.length) return [];

    return [...trait_tiers].sort((a, b) => b.percentage - a.percentage);
  }, [trait_tiers]);

  const getTierName = (value) => {
    if (!sortedTiers.length) return null;

    for (let i = 0; i < sortedTiers.length; i++) {
      if (value >= sortedTiers[i].percentage) {
        return sortedTiers[i].tier_name;
      }
    }

    return sortedTiers[sortedTiers.length - 1].tier_name;
  };

  useEffect(() => {
    const target = document.querySelector(".newdash-sections");
    if (target) {
      const offsetTop =
        target.getBoundingClientRect().top + window.pageYOffset - 220;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  }, [page]);

  useEffect(() => {
  if (HeaderTest?.dimension?.detailimage) {
    const imageUrl = `${IMG_URL}/d0/${HeaderTest?.dimension?.detailimage}`;

    preloadImage(imageUrl)
      .then(() => {
        console.log("Archetype image preloaded");
      })
      .catch(() => {
        console.log("Failed to preload archetype image");
      });
  }
}, [HeaderTest]);

  const Bgcolors = ["#ebddf1", "#afe2ca", "#c6f5ff", "#f4e9c7", "#ffaeb5"];

  if (!isVisible) {
    return (
      <div className="loadingDiv">
        <img src={gg} alt="Loading..." />
      </div>
    );
  }

  const handleNotificationClick = async (item) => {
    try {
      navigate(`/${item.url}`);
    } catch (error) {
      console.error("Failed to update notification", error);
      navigate(`/${item.url}`);
    }
  };

  // useEffect(() => {

  //   if (HeaderTest?.dimension?.detailimage) {
  //     const imageUrl = `${IMG_URL}/d0/${HeaderTest?.dimension?.detailimage}`;

  //     preloadImage(imageUrl)
  //       .then(() => {
  //         console.log("Archetype image preloaded");
  //       })
  //       .catch(() => {
  //         console.log("Failed to preload archetype image");
  //       });
  //   }
  // }, [HeaderTest]);

  return (

    <>
    <Helmet>

        <link rel="preload" as="image" href={`${IMG_URL}/d0/${JourneyData?.core?.journey_image}`} />

        <link rel="preload" as="image" href={`${IMG_URL}/d0/${JourneyData?.insight?.journey_image}`} />

         {HeaderTest?.dimension?.detailimage && (
            <link
              rel="preload"
              as="image"
              href={`${IMG_URL}/d0/${HeaderTest?.dimension?.detailimage}`}
            />
          )}

    </Helmet>

    <div className="new-cont result-cont newdash-main">
      <div className="container-fluid for-sidebar1">
        <div className="row result-cont">
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res sidebar-wrapper1 newdsh-siderDash">
            {token && <Dashboard globaltest={globaltest} />}

            <div className="noti-posts">
              <h2 className="common-title">
                {DataContent["common_notification_title"]}
              </h2>

              {Array.isArray(Notification) && Notification.length > 0 ? (
                Notification.map((item, index) => (
                  <div key={index} className="notification-card">
                    <div className="notification-body">
                      <h3>{item?.title}</h3>

                      {item.type === "text" && item.content && (
                        <div
                          className="notification-text"
                          dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                      )}

                      {item.type === "image" && item.image && (
                        <div className="notification-image">
                          <img
                            src={`${IMG_URL}/d0/${item.image}`}
                            alt="Notification"
                            className="img-fluid"
                          />
                        </div>
                      )}

                      {item.button && item.url && (
                        <a className="nav-head-out-btn  view-all-meetings-btn noti-view-link">
                          <button
                            className="nav-head-out-btn-text noti-view"
                            onClick={() => handleNotificationClick(item)}
                          >
                            {item.button}

                            <span>
                              <FontAwesomeIcon
                                className="icc"
                                icon={faArrowRight}
                              />
                            </span>
                          </button>
                        </a>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-notification">
                  <p>No notifications available.</p>
                </div>
              )}
            </div>

            <div className="dash-side-left-repo">
              <div className="newdash-boxes">
                {BadgeImage && IsTest ? (
                  <div
                    className="newdash-boxes-b1 newdash-boxes-first"
                    style={{
                      backgroundColor: DataContent["badge_bg_color"],
                    }}
                  >
                    <h5>{DataContent["badge_label_dash"]}</h5>
                    <div>
                      <img src={`${IMG_URL}/d0/${BadgeImage}`} alt="" />
                    </div>
                    <a href="/achievements" className="button common">
                      <span>{DataContent["badge_button_label_dash"]}</span>
                      <span>
                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                      </span>
                    </a>
                  </div>
                ) : (
                  <div className="newdash-boxes-b1 newdash-boxes-first newdash-boxes-first-notest no-test">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DataContent["no_test_content"],
                      }}
                    />
                    <a
                      href={`test/${free_test_slug}`}
                      className="button common"
                    >
                      <span>{DataContent["no_test_btn_label"]}</span>
                      <span>
                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                      </span>
                    </a>
                  </div>
                )}

                {Ebook ? (
                  <div
                    className="newdash-boxes-b1 newdash-boxes-first newdash-boxes-second-pdf pdfDiv"
                    style={{
                      backgroundColor: DataContent["ebook_bg_color"],
                    }}
                  >
                    <div className="ebook-pdfDiv1">
                      <h5>{DataContent["ebook_label_dash"]}</h5>
                      <div>
                        <h6>{Ebook.name}</h6>
                        {Ebook.pdf_image ? (
                          <a className="dmd-ebook" href="/ebook">
                            <img
                              src={`${IMG_URL}/d0/${Ebook.pdf_image}`}
                              alt="pdf-image"
                            />
                          </a>
                        ) : (
                          <p>PDF not available</p>
                        )}
                        <a href="/ebook" className="ebook-btn-a">
                        <span> {DataContent["ebook_button_dash"]}</span> 
                          <span>
                            <FontAwesomeIcon
                              className="icc"
                              icon={faArrowRight}
                            />
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="newdash-boxes-b1 newdash-boxes-second not-pdf-img">
                    <div className="newdash-boxes-b1-inner">
                      <div
                        className="oor"
                        dangerouslySetInnerHTML={{
                          __html: DataContent["no_ebook_content"],
                        }}
                      />
                      <a href={`/ebook`} className="button common">
                        <span>{DataContent["no_ebook_btn_label"]}</span>
                        <span>
                          <FontAwesomeIcon
                            className="icc"
                            icon={faArrowRight}
                          />
                        </span>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={`col-12 col-sm-12 col-md-9 col-lg-9 newdash-col`}>
            <div className="row newdash-right">
              <div className="col-12 col-md-12 title-newdash">
                <h3>
                  Welcome {first_login ? "" : "Back"} {user?.name},
                </h3>
                {HeaderTest?.welcome_content && (
                  <p>{HeaderTest?.welcome_content}</p>
                )}

                {/* <div className="header-test">
                      {HeaderTest?.test_link && (
                        <div className="left-test-header">
                          <a href={`/${HeaderTest?.test_link}`}>
                            <img
                              src={`${IMG_URL}/d0/${HeaderTest?.latest_arche_image}`}
                            />
                          </a>
                        </div>
                      )}

                      {HeaderTest?.diemma_test_link && (
                        <div className="right-test-header">
                          <a href={`/dilemma/${HeaderTest?.diemma_test_link}`}>
                            <img
                              src={`${IMG_URL}/d0/${HeaderTest?.diemma_test_link_image}`}
                            />
                          </a>
                        </div>
                      )}
                  </div> */}
              </div>

              <div className="col-12 col-md-8 newdash-sections">
                <div className="dashboard-two-section-call">
                  <DashboardTwoCard
                    onLoginChange={onLoginChange}
                    userdetail={userdetail}
                    token={token}
                    handleNavigete={handleNavigete}
                    handleSub={handleSub}
                    journey_data={JourneyData}
                    HeaderTest={HeaderTest}
                  />
                </div>

                {UserData.length > 0 ? (
                  <div className="newdash-graph-main">
                    <h4>Archetype Timeline</h4>

                    <div
                      className={`newdash-graph-outer ${
                        isTransitioning ? slideDirection : ""
                      }`}
                    >
                      <div className="row newdash-graph-inner-row">
                        <div className="newdash-graph">
                          {UserData.length > 0 && (
                            <div className="col-md-12 first-name">
                              {UserData.map((user, rowIndex) => (
                                <div className="row newdash-tab" key={rowIndex}>
                                  {TestDates.map((date, colIndex) => {
                                    const testData = user[date];
                                    return (
                                      <React.Fragment key={colIndex}>
                                        {colIndex === 0 &&
                                          (rowIndex === UserData.length - 1 ? (
                                            <div className="col-md-2_5">
                                              <p>Quizzes Taken</p>
                                            </div>
                                          ) : (
                                            <div className="col-md-2_5"></div>
                                          ))}

                                        <div className="col-md-2_5">
                                          {testData && (
                                            <>
                                              <div
                                                style={{
                                                  backgroundColor:
                                                    Bgcolors[
                                                      colIndex % Bgcolors.length
                                                    ],
                                                }}
                                                onClick={() => {
                                                  if (testData?.test_link) {
                                                    window.location.href = `/${testData.test_link}`;
                                                  }
                                                }}
                                              >
                                                {testData?.conductor_image ? (
                                                  <img
                                                    src={`${IMG_URL}/d0/${testData?.conductor_image}`}
                                                    alt={
                                                      testData?.conducter_name
                                                    }
                                                  />
                                                ) : (
                                                  <img src={noimage} />
                                                )}

                                                <span>
                                                  {testData?.conducter_name}
                                                </span>
                                              </div>
                                              <p>{testData?.test_name}</p>
                                            </>
                                          )}
                                        </div>
                                      </React.Fragment>
                                    );
                                  })}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="col-md-12 last-date">
                          <div className="row newdash-tab">
                            <div className="col-md-2_5">Date</div>
                            {TestDates &&
                              TestDates.length > 0 &&
                              TestDates.map((item, index) => (
                                <div key={index} className="col-md-2_5">
                                  {item}
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="no-login-result resutalljsx user-result-no">
                    <div
                      className="result-no-content"
                      dangerouslySetInnerHTML={{
                        __html: DataContent["no_test_content_section"],
                      }}
                    />
                    <a
                      className="button"
                      // href={`/${DataContent["no_test_btn_link_section"]}`}
                      onClick={
                        TestLink != "" && TestLink != null
                          ? () => handleNavigete(TestLink)
                          : () =>
                              handleAdSub(
                                DataContent["no_test_btn_link_section"],
                              )
                      }
                    >
                      {DataContent["no_test_btn_label_section"]}
                      <span>
                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                      </span>
                    </a>
                  </div>
                )}

                {UserData.length > 0 && (
                  <div className="ques-btn view-all-meetings dashboard-graph-butn">
                    <a className="nav-head-out-btn combine-btn view-all-meetings-btn">
                      <button
                        className="nav-head-out-btn-text view-all-meetings-btn-link"
                        onClick={() => navigate("/all-result-grapth")}
                      >
                        {DataContent["result_view_all_btn"]}

                        <span>
                          <FontAwesomeIcon
                            className="icc"
                            icon={faArrowRight}
                          />
                        </span>
                      </button>
                    </a>
                  </div>
                )}

                {testData && Demension?.name && (
                  <div className="dash-cont-round-graph-call">
                    <div className="dash-doughrt-btns">
                      <h4>
                        {" "}
                        {testData?.test?.result_display_name} - {Demension?.name}{" "}
                        {result_letter
                          ?.map((item) => item.final_letter)
                          .join(" ")}{" "}
                      </h4>

                      <a
                        href={`/${testData?.test_link}`}
                        class="continue-btn new-commom-btn"
                      >
                        <span>See Full Results</span>

                        <span class="righ-arr">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    </div>

                    <div className="row">
                      {traits.map((trait, index) => {
                        const tierName = getTierName(trait.value);
                        const tierInfo = trait_tiers?.find(
                          (t) => t.tier_name === tierName,
                        );
                        return (
                          <div className="col-md-2">
                            <div
                              className={`dash-doghnut-cir ${showlock && trait?.showlock ? "show_lock" : ""}`}

                              onClick={
                                showlock && trait?.showlock
                                  ? () => handleSub(testData?.test_sub_ids)
                                  : undefined
                              }
                            >
                              <DoughnutLinearChart
                                key={index}
                                value={trait.value}
                                label={trait.label}
                                subLabel={tierInfo?.title || tierName}
                                description={trait?.content || ""}
                                tierName={tierName}
                                TriatData={tierInfo}
                                bg_color_1={trait?.bg_color_1}
                                bg_color_2={trait?.bg_color_2}
                                showlock={false}
                              />

                              <div className="dash-doghnut-content">
                                <p>{trait.label}</p>
                                <div
                                  style={{ backgroundColor: trait?.bg_color_2 }}
                                >
                                  <img
                                    src={`${IMG_URL}/d0/${tierInfo?.trait_icon}`}
                                    alt=""
                                  />
                                  <span>{tierName}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {testData  &&!testData?.test_done_subscription && showlock && (

                    <div className="newdash-cta-div">
                      <div className="newdash-cta-div-outer">

                        <div
                          dangerouslySetInnerHTML={{
                            __html: testData?.test_popup_content?.unlock_full_pattern || ""
                          }}
                        />

                        <a
                          class={`continue-btn new-commom-btn`}
                          onClick={() => handleSub(testData?.test_sub_ids)}
                        >
                          <div>
                            <img src={ww} alt="" />
                          </div>

                          <span>{testData?.test_popup_content?.unlock_full_button_label}</span>

                          <span class="righ-arr">
                            <FontAwesomeIcon icon={faArrowRight} />
                          </span>
                        </a>
                      </div>
                    </div>
                )}

                {Avertisment && Avertisment.length > 0 && (
                  <div className="newdash-advert-side newdash-advertisement-tab adver-mob-sec">
                    <div className="col-md-4 side-mob">
                      <div className="row">
                        {HeaderTest &&
                          Object.keys(HeaderTest).length > 0 &&
                          HeaderTest?.dimension && (
                            <div className="col-md-12">
                              <div className="dash-side-new-section">
                                <div className="dash-side-img-box">
                                  <h4>
                                    My Archetype:{" "}
                                    {HeaderTest?.dimension?.name}{" "}
                                  </h4>

                                  <div className="dash-sideimgDiv notpaid-btn">
                                    <img
                                      src={`${IMG_URL}/d0/${HeaderTest?.dimension?.detailimage}`}
                                      alt=""
                                    />

                                    {!HeaderTest?.sub_true && (
                                      <a
                                        onClick={
                                          HeaderTest?.sub_true
                                            ? () =>
                                                handleNavigeteTest(
                                                  HeaderTest?.test_link,
                                                )
                                            : () =>
                                                handleResult(
                                                  HeaderTest?.sub_ids,
                                                )
                                        }
                                        className="continue-btn new-commom-btn"
                                      >
                                        <span>
                                          {
                                            HeaderTest?.dashboard_free_test_btn_label
                                          }
                                        </span>

                                        <span class="righ-arr">
                                          <FontAwesomeIcon
                                            icon={faArrowRight}
                                          />
                                        </span>
                                      </a>
                                    )}
                                  </div>

                                  {HeaderTest?.sub_true && (
                                    <div className="dash-side-btn-title">
                                      <div
                                        className="paid-dash-test"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            HeaderTest?.dimension
                                              ?.dash_paid_content,
                                        }}
                                      />

                                      <a
                                        onClick={() =>
                                          handleNavigeteTest(
                                            HeaderTest?.test_link,
                                          )
                                        }
                                        className="continue-btn new-commom-btn"
                                      >
                                        <span>
                                          {
                                            HeaderTest?.dashboard_free_test_btn_label
                                          }
                                        </span>

                                        <span class="righ-arr">
                                          <FontAwesomeIcon
                                            icon={faArrowRight}
                                          />
                                        </span>
                                      </a>
                                    </div>
                                  )}

                                  <div
                                    className={`dash-side-boxes notpaid ${HeaderTest?.sub_true ? "paid_content" : ""}`}
                                  >
                                    {!HeaderTest?.sub_true && (
                                      <div
                                        className="dash-side-notpaid"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            HeaderTest?.dashboard_free_test_content,
                                        }}
                                      />
                                    )}

                                    {HeaderTest?.sub_true && (
                                      <>
                                        {HeaderTest?.dimension?.breakdown
                                          ?.break_down_content_1 && (
                                          <div className="dash-side-subBox">
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  HeaderTest?.dimension
                                                    ?.breakdown
                                                    ?.break_down_content_1,
                                              }}
                                            />

                                            <span>
                                              <img src={v1} alt="" />
                                            </span>
                                          </div>
                                        )}

                                        {HeaderTest?.dimension?.breakdown
                                          ?.break_down_content_2 && (
                                          <div className="dash-side-subBox">
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  HeaderTest?.dimension
                                                    ?.breakdown
                                                    ?.break_down_content_2,
                                              }}
                                            />

                                            <span>
                                              <img src={v2} alt="" />
                                            </span>
                                          </div>
                                        )}

                                        {HeaderTest?.dimension?.breakdown
                                          ?.break_down_content_3 && (
                                          <div className="dash-side-subBox">
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  HeaderTest?.dimension
                                                    ?.breakdown
                                                    ?.break_down_content_3,
                                              }}
                                            />

                                            <span>
                                              <img src={v3} alt="" />
                                            </span>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                        <div className="col-md-12">
                          <div className="dash-side-img-ad">
                            <h4>{DataContent["dash_adver_label"]}</h4>
                            {Avertisment.map((item, index) => (
                              <div
                                key={index}
                                className="newdash-advertisement "
                              >
                                <div className="sid-mm">
                                  <img
                                    src={`${IMG_URL}/d0/${item?.file_name}`}
                                    alt=""
                                  />
                                </div>
                                <div
                                  className={`ad-cont ${item?.advertisment_content ? "" : "no-content"}`}
                                >
                                  <div>
                                    {item?.advertisment_content && (
                                      <div
                                        className="ad-content"
                                        dangerouslySetInnerHTML={{
                                          __html: item?.advertisment_content,
                                        }}
                                      />
                                    )}

                                    {item?.advertisment_icon && (
                                      <span>
                                        <img
                                          src={`${IMG_URL}/d0/${item?.advertisment_icon}`}
                                          alt=""
                                        />
                                      </span>
                                    )}
                                  </div>

                                  <a
                                    onClick={
                                      item?.test_link != "" &&
                                      item?.test_link != null
                                        ? () =>
                                            handleNavigete(
                                              item?.test_link?.slug,
                                            )
                                        : () => handleSub(item.link)
                                    }
                                    className="continue-btn new-commom-btn"
                                  >
                                    <span>{item.advertisment_button}</span>

                                    <span class="righ-arr">
                                      <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                  </a>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="new-dash-mob-full">
                  <div className="noti-posts">
                    <h2 className="common-title">
                      {DataContent["common_notification_title"]}
                    </h2>

                    {Array.isArray(Notification) && Notification.length > 0 ? (
                      Notification.map((item, index) => (
                        <div key={index} className="notification-card">
                          <div className="notification-body">
                            <h3>{item?.title}</h3>

                            {item.type === "text" && item.content && (
                              <div
                                className="notification-text"
                                dangerouslySetInnerHTML={{
                                  __html: item.content,
                                }}
                              />
                            )}

                            {item.type === "image" && item.image && (
                              <div className="notification-image">
                                <img
                                  src={`${IMG_URL}/d0/${item.image}`}
                                  alt="Notification"
                                  className="img-fluid"
                                />
                              </div>
                            )}

                            {item.button && item.url && (
                              <a className="nav-head-out-btn  view-all-meetings-btn noti-view-link">
                                <button
                                  className="nav-head-out-btn-text noti-view"
                                  onClick={() => handleNotificationClick(item)}
                                >
                                  {item.button}

                                  <span>
                                    <FontAwesomeIcon
                                      className="icc"
                                      icon={faArrowRight}
                                    />
                                  </span>
                                </button>
                              </a>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="no-notification">
                        <p>No notifications available.</p>
                      </div>
                    )}
                  </div>

                  <div className="dash-side-left-repo">
                    <div className="newdash-boxes">
                      {BadgeImage && IsTest ? (
                        <div
                          className="newdash-boxes-b1 newdash-boxes-first"
                          style={{
                            backgroundColor: DataContent["badge_bg_color"],
                          }}
                        >
                          <h5>{DataContent["badge_label_dash"]}</h5>
                          <div>
                            <img src={`${IMG_URL}/d0/${BadgeImage}`} alt="" />
                          </div>
                          <a href="/achievements" className="button common">
                            <span>
                              {DataContent["badge_button_label_dash"]}
                            </span>
                            <span>
                              <FontAwesomeIcon
                                className="icc"
                                icon={faArrowRight}
                              />
                            </span>
                          </a>
                        </div>
                      ) : (
                        <div className="newdash-boxes-b1  newdash-boxes-first newdash-boxes-first-notest no-test">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DataContent["no_test_content"],
                            }}
                          />
                          <a
                            href={`test/${free_test_slug}`}
                            className="button common"
                          >
                            <span>{DataContent["no_test_btn_label"]}</span>
                            <span>
                              <FontAwesomeIcon
                                className="icc"
                                icon={faArrowRight}
                              />
                            </span>
                          </a>
                        </div>
                      )}

                      {Ebook ? (
                        <div
                          className="newdash-boxes-b1 newdash-boxes-first newdash-boxes-second-pdf pdfDiv"
                          style={{
                            backgroundColor: DataContent["ebook_bg_color"],
                          }}
                        >
                          <div className="ebook-pdfDiv1">
                            <h5>{DataContent["ebook_label_dash"]}</h5>
                            <div>
                              <h6>{Ebook.name}</h6>
                              {Ebook.pdf_image ? (
                                <a className="dmd-ebook" href="/ebook">
                                  <img
                                    src={`${IMG_URL}/d0/${Ebook.pdf_image}`}
                                    alt="pdf-image"
                                  />
                                </a>
                              ) : (
                                <p>PDF not available</p>
                              )}
                              <a href="/ebook" className="ebook-btn-a">
                               <span>  {DataContent["ebook_button_dash"]}</span>
                                <span>
                                  <FontAwesomeIcon
                                    className="icc"
                                    icon={faArrowRight}
                                  />
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="newdash-boxes-b1 newdash-boxes-second not-pdf-img">
                          <div className="newdash-boxes-b1-inner">
                            <div
                              className="oor"
                              dangerouslySetInnerHTML={{
                                __html: DataContent["no_ebook_content"],
                              }}
                            />
                            <a href={`/ebook`} className="button common">
                              <span>{DataContent["no_ebook_btn_label"]}</span>
                              <span>
                                <FontAwesomeIcon
                                  className="icc"
                                  icon={faArrowRight}
                                />
                              </span>
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {DataContent["sub_bottom_image"] && (
                  <div
                    className="newdash-advertise"
                    // onClick={() =>
                    //   handleAdClick(DataContent["sub_bottom_image_link"])
                    // }

                    onClick={
                      TestLink2 != "" && TestLink2 != null
                        ? () => handleNavigete(TestLink2)
                        : () => handleSub(DataContent["sub_bottom_image_link"])
                    }
                  >
                    <img
                      src={`${IMG_URL}/d0/${DataContent["sub_bottom_image"]}`}
                      alt="adver1"
                    />
                  </div>
                )}
              </div>

              {Avertisment && Avertisment.length > 0 && (
                <div className="col-md-4 side-desk">
                  <div className="row">
                    {HeaderTest &&
                      Object.keys(HeaderTest).length > 0 &&
                      HeaderTest?.dimension && (
                        <div className="col-md-12">
                          <div className="dash-side-new-section">
                            <div className="dash-side-img-box">
                              <h4>
                                My Archetype: {HeaderTest?.dimension?.name}{" "}
                              </h4>

                              <div className="dash-sideimgDiv notpaid-btn">
                                <img
                                  src={`${IMG_URL}/d0/${HeaderTest?.dimension?.detailimage}`}
                                  alt=""
                                />

                                {!HeaderTest?.sub_true && (
                                  <a
                                    onClick={
                                      HeaderTest?.sub_true
                                        ? () =>
                                            handleNavigeteTest(
                                              HeaderTest?.test_link,
                                            )
                                        : () =>
                                            handleResult(HeaderTest?.sub_ids)
                                    }
                                    className="continue-btn new-commom-btn"
                                  >
                                    <span>
                                      {
                                        HeaderTest?.dashboard_free_test_btn_label
                                      }
                                    </span>

                                    <span class="righ-arr">
                                      <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                  </a>
                                )}
                              </div>

                              {HeaderTest?.sub_true && (
                                <div className="dash-side-btn-title">
                                  <div
                                    className="paid-dash-test"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        HeaderTest?.dimension
                                          ?.dash_paid_content,
                                    }}
                                  />

                                  <a
                                    onClick={() =>
                                      handleNavigeteTest(HeaderTest?.test_link)
                                    }
                                    className="continue-btn new-commom-btn"
                                  >
                                    <span>
                                      {
                                        HeaderTest?.dashboard_free_test_btn_label
                                      }
                                    </span>

                                    <span class="righ-arr">
                                      <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                  </a>
                                </div>
                              )}

                              <div
                                className={`dash-side-boxes notpaid ${HeaderTest?.sub_true ? "paid_content" : ""}`}
                              >
                                {!HeaderTest?.sub_true && (
                                  <div
                                    className="dash-side-notpaid"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        HeaderTest?.dashboard_free_test_content,
                                    }}
                                  />
                                )}

                                {HeaderTest?.sub_true && (
                                  <>
                                    {HeaderTest?.dimension?.breakdown
                                      ?.break_down_content_1 && (
                                      <div className="dash-side-subBox">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              HeaderTest?.dimension?.breakdown
                                                ?.break_down_content_1,
                                          }}
                                        />

                                        <span>
                                          <img src={v1} alt="" />
                                        </span>
                                      </div>
                                    )}

                                    {HeaderTest?.dimension?.breakdown
                                      ?.break_down_content_2 && (
                                      <div className="dash-side-subBox">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              HeaderTest?.dimension?.breakdown
                                                ?.break_down_content_2,
                                          }}
                                        />

                                        <span>
                                          <img src={v2} alt="" />
                                        </span>
                                      </div>
                                    )}

                                    {HeaderTest?.dimension?.breakdown
                                      ?.break_down_content_3 && (
                                      <div className="dash-side-subBox">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              HeaderTest?.dimension?.breakdown
                                                ?.break_down_content_3,
                                          }}
                                        />

                                        <span>
                                          <img src={v3} alt="" />
                                        </span>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    <div className="col-md-12">
                      <div className="dash-side-img-ad">
                        <h4>{DataContent["dash_adver_label"]}</h4>
                        {Avertisment.map((item, index) => (
                          <div key={index} className="newdash-advertisement">
                            <div className="sid-mm">
                              <img
                                src={`${IMG_URL}/d0/${item?.file_name}`}
                                alt=""
                              />
                            </div>
                            <div
                              className={`ad-cont ${item?.advertisment_content ? "" : "no-content"}`}
                            >
                              <div>
                                {item?.advertisment_content && (
                                  <div
                                    className="ad-content"
                                    dangerouslySetInnerHTML={{
                                      __html: item?.advertisment_content,
                                    }}
                                  />
                                )}

                                {item?.advertisment_icon && (
                                  <span>
                                    <img
                                      src={`${IMG_URL}/d0/${item?.advertisment_icon}`}
                                      alt=""
                                    />
                                  </span>
                                )}
                              </div>

                              <a
                                onClick={
                                  item?.test_link != "" &&
                                  item?.test_link != null
                                    ? () =>
                                        handleNavigete(item?.test_link?.slug)
                                    : () => handleSub(item.link)
                                }
                                className="continue-btn new-commom-btn"
                              >
                                <span>{item.advertisment_button}</span>

                                <span class="righ-arr">
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* call the new side menu bar */}

          {Avertisment && Avertisment.length > 0 && (
            <div className="col-md-4 side-desk side-desk-tab">
              <div className="row">
                {HeaderTest &&
                  Object.keys(HeaderTest).length > 0 &&
                  HeaderTest?.dimension && (
                    <div className="col-md-12">
                      <div className="dash-side-new-section">
                        <div className="dash-side-img-box">
                          <h4>My Archetype: {HeaderTest?.dimension?.name} </h4>

                          <div className="dash-sideimgDiv notpaid-btn">
                            <img
                              src={`${IMG_URL}/d0/${HeaderTest?.dimension?.detailimage}`}
                              alt=""
                            />

                            {!HeaderTest?.sub_true && (
                              <a
                                onClick={
                                  HeaderTest?.sub_true
                                    ? () =>
                                        handleNavigeteTest(
                                          HeaderTest?.test_link,
                                        )
                                    : () => handleResult(HeaderTest?.sub_ids)
                                }
                                className="continue-btn new-commom-btn"
                              >
                                <span>
                                  {HeaderTest?.dashboard_free_test_btn_label}
                                </span>

                                <span class="righ-arr">
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                              </a>
                            )}
                          </div>

                          {HeaderTest?.sub_true && (
                            <div className="dash-side-btn-title">
                              <div
                                className="paid-dash-test"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    HeaderTest?.dimension?.dash_paid_content,
                                }}
                              />

                              <a
                                onClick={() =>
                                  handleNavigeteTest(HeaderTest?.test_link)
                                }
                                className="continue-btn new-commom-btn"
                              >
                                <span>
                                  {HeaderTest?.dashboard_free_test_btn_label}
                                </span>

                                <span class="righ-arr">
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                              </a>
                            </div>
                          )}

                          <div
                            className={`dash-side-boxes notpaid ${HeaderTest?.sub_true ? "paid_content" : ""}`}
                          >
                            {!HeaderTest?.sub_true && (
                              <div
                                className="dash-side-notpaid"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    HeaderTest?.dashboard_free_test_content,
                                }}
                              />
                            )}

                            {HeaderTest?.sub_true && (
                              <>
                                {HeaderTest?.dimension?.breakdown
                                  ?.break_down_content_1 && (
                                  <div className="dash-side-subBox">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          HeaderTest?.dimension?.breakdown
                                            ?.break_down_content_1,
                                      }}
                                    />

                                    <span>
                                      <img src={v1} alt="" />
                                    </span>
                                  </div>
                                )}

                                {HeaderTest?.dimension?.breakdown
                                  ?.break_down_content_2 && (
                                  <div className="dash-side-subBox">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          HeaderTest?.dimension?.breakdown
                                            ?.break_down_content_2,
                                      }}
                                    />

                                    <span>
                                      <img src={v2} alt="" />
                                    </span>
                                  </div>
                                )}

                                {HeaderTest?.dimension?.breakdown
                                  ?.break_down_content_3 && (
                                  <div className="dash-side-subBox">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          HeaderTest?.dimension?.breakdown
                                            ?.break_down_content_3,
                                      }}
                                    />

                                    <span>
                                      <img src={v3} alt="" />
                                    </span>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                <div className="col-md-12">
                  <div className="dash-side-img-ad">
                    <h4>{DataContent["dash_adver_label"]}</h4>
                    {Avertisment.map((item, index) => (
                      <div key={index} className="newdash-advertisement">
                        <div className="sid-mm">
                          <img
                            src={`${IMG_URL}/d0/${item?.file_name}`}
                            alt=""
                          />
                        </div>
                        <div
                          className={`ad-cont ${item?.advertisment_content ? "" : "no-content"}`}
                        >
                          <div>
                            {item?.advertisment_content && (
                              <div
                                className="ad-content"
                                dangerouslySetInnerHTML={{
                                  __html: item?.advertisment_content,
                                }}
                              />
                            )}

                            {item?.advertisment_icon && (
                              <span>
                                <img
                                  src={`${IMG_URL}/d0/${item?.advertisment_icon}`}
                                  alt=""
                                />
                              </span>
                            )}
                          </div>

                          <a
                            onClick={
                              item?.test_link != "" && item?.test_link != null
                                ? () => handleNavigete(item?.test_link?.slug)
                                : () => handleSub(item.link)
                            }
                            className="continue-btn new-commom-btn"
                          >
                            <span>{item.advertisment_button}</span>

                            <span class="righ-arr">
                              <FontAwesomeIcon icon={faArrowRight} />
                            </span>
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!first_login && (
            <div className="newdashpop-overlay">
              <div className="newdashpop-inner">
                <div className="newdashpop-container">
                  <button
                    className="newdashpop-close"
                    onClick={handleFirstLoginClose}
                  >
                    &times;
                  </button>

                  {DataContent["sub_pop_up_title"] && (
                    <h3 className="newdashpop-title">
                      {DataContent["sub_pop_up_title"]}
                    </h3>
                  )}

                  {DataContent["sub_pop_up_content"] && (
                    <div
                      className="conent-pop"
                      dangerouslySetInnerHTML={{
                        __html: DataContent["sub_pop_up_content"],
                      }}
                    />
                  )}

                  {!iamgeload && (
                    <div className="image-popup">
                      <div
                        className="skeleton3-loader skeleton3"
                        style={{
                          // width: "100%",

                          // minHeight:'240px',
                          // background:
                          //   "linear-gradient(90deg,#e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)",
                          // backgroundSize: "400% 100%",
                          // animation: "shimmer 1.4s ease infinite",
                          borderRadius: "10px",
                          minHeight: "240px",
                        }}
                      ></div>
                    </div>
                  )}

                  {DataContent["sub_pop_up_image"] && (
                    <div className="image-popup">
                      <img
                        src={`${IMG_URL}/d0/${DataContent["sub_pop_up_image"]}`}
                        alt="popup-image"
                        style={{ display: iamgeload ? "block" : "none" }}
                        onLoad={() => setiamgeload(true)}
                      />
                    </div>
                  )}

                  {DataContent["sub_pop_up_button"] &&
                    DataContent["sub_pop_up_button_link"] && (
                      <a
                        className="home-slider-sun-box-a"
                        onClick={
                          TestLink != "" && TestLink != null
                            ? () => handleNavigeteTest(TestLink)
                            : () =>
                                handleAdSub(
                                  DataContent["sub_pop_up_button_link"],
                                )
                        }
                        rel="noopener noreferrer"
                      >
                        <span className="home-slider-sun-box-a-text">
                          {DataContent["sub_pop_up_button"]}
                        </span>
                        <span className="home-slider-sun-box-a-icon">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    )}
                </div>
              </div>
            </div>
          )}

          {LockModal && (
            <div className={`newdashpop-overlay lock-dashboard`}>
              <div className="newdashpop-inner">
                <div className="newdashpop-container">
                  <button
                    className="newdashpop-close"
                    onClick={() => setLockModal(false)}
                  >
                    &times;
                  </button>

                  <div className="conent-pop lock-dashboard-content">
                    <div className="dash-loc-title">
                      <span>
                        <img src={ww} alt="" />
                      </span>{" "}
                      <h3>Unlock Your Full 6 -Trait Blue Prints</h3>
                    </div>
                    <p>
                      Notre mission est de fournir des solutions électriques
                      innovantes, durables et efficaces pour les bâtiments
                      résidentiels et commerciaux. Guidés par
                    </p>

                    <div className="dash-lock-icons">
                      <div className="dash-lock-icons-box">
                        <span>
                          <img src={ww} alt="" />
                        </span>
                        <p>Your Full 6 -Trait Blue Prints</p>
                      </div>

                      <div className="dash-lock-icons-box">
                        <span>
                          <img src={ww} alt="" />
                        </span>
                        <p>Your Full 6 -Trait Blue Prints</p>
                      </div>

                      <div className="dash-lock-icons-box">
                        <span>
                          <img src={ww} alt="" />
                        </span>
                        <p>Your Full 6 -Trait Blue Prints</p>
                      </div>
                    </div>

                      <a className="home-slider-sun-box-a"  onClick={() => handleSub(testData?.test_sub_ids)} >
                        <span className="home-slider-sun-box-a-text">
                      Unlock My Full Personality Blue Print
                        </span>
                        <span className="home-slider-sun-box-a-icon img-icon">
                          {/* <FontAwesomeIcon icon={faArrowRight} /> */}
                          <img src={ww} alt="" />
                        </span>
                      </a>

                      <span>We’re proud to showcase the transformations</span>

                  </div>
                </div>
              </div>
            </div>
          )}

          {ShowModal && (
            <div
              className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                subscription?.data?.length == 1 ? "single-subscription" : ""
              }`}
            >
              <div className="newdashpop-inner">
                <div className="newdashpop-container">
                  <button
                    className="newdashpop-close"
                    onClick={() => setShowModal(false)}
                  >
                    &times;
                  </button>

                  <div className="conent-pop">
                    <Subscriptions
                      subs={subS}
                      userdetail={
                        showResult
                          ? { ...userdetail, user_all_access: "0" }
                          : userdetail
                      }
                      force_to_disable={showResult ? false : true}
                      Subcription={subscription}
                      onLoginChange={onLoginChange}
                      free_popup={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

    </>
  );
}

export default NewDashboard;
